import { Container } from '@chakra-ui/react'
import { FC } from 'react'

const OnboardingContainer: FC<any> = ({ children }) => {
  return <Container maxWidth={500}>{children}</Container>
}

export default OnboardingContainer
